import axios from 'axios'
import type { InternalAxiosRequestConfig } from 'axios'
import { getApiEndpoint } from '~/helpers/api'

export function getViewAsUserQueryValue() {
  // Get the query string from the current URL
  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)
  // Get the value of the "viewAsUser" query parameter
  const viewAsUserValue = urlParams.get('viewAsUser')
  return viewAsUserValue
}

const createHeaders = () => {
  if (!window) return {}
  const viewAsUser = getViewAsUserQueryValue()
  return {
    ...(viewAsUser && { 'X-View-As': viewAsUser }),
  }
}

const instance = axios.create({
  transformResponse: (data) => data, // this line here
  withCredentials: true,
})

// Add a request interceptor
axios.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // Do something before request is sent
    config.baseURL = getApiEndpoint()
    config.withCredentials = true
    config.headers = {
      ...config.headers,
      ...createHeaders(),
    }

    return config
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error)
  }
)

const fileInstance = axios.create({
  transformResponse: (data) => data,
  withCredentials: true,
})
fileInstance.interceptors.request.use((config) => {
  return { ...config, responseType: 'blob' }
})

export { fileInstance }

export default instance
